import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import ServicesSection from '../components/ServicesSection';
import FormationsSection from '../components/FormationsSection';
import OurPartners from '../components/OurPartners';


const Home = () => {
  return (
    <>
    <Header />
    <Hero />
    <OurPartners />
    <FormationsSection />
    <ServicesSection />
    <div>
        
    </div>
    <Footer />
    </>
  );
};
export default Home;